<h1 class="text-center d-flex align-items-center justify-content-between" mat-dialog-title>
  <span>{{'insurance-providers' | translate}}</span>
  <span (click)="closeDialog()" [inlineSVG]="'assets/img/times1.svg'"
        class="svg-15 d-flex align-items-center justify-content-center"></span>
</h1>
<div class="mb-4" mat-dialog-content>
  <ul class="pl-3">
    <li *ngFor="let provider of data.providers" class="insurance-provider cursor-pointer mb-3"
        (click)="redirectToSearchByProviderId(provider)">
      {{provider.value}} <!-- ???translate??? -->
    </li>
  </ul>
</div>

